import { useSelector } from 'react-redux';

const useAuth = () => {
  const { user, isAuthenticated, loading, token } = useSelector(
    (state) => state.auth
  );

  const role = user?.role || null;
  const isCustomer = role === 'customer';
  const isDoctor = role === 'doctor';
  const isHospitalAdmin = role === 'hospital_admin';
  const isAdmin = role === 'admin';

  // Laboratory access, from the `lab` block of the login / profile payload.
  // A platform admin reaches every lab (choosing the hospital per request).
  const lab = user?.lab || null;
  const labPermissions = new Set(lab?.enabled ? lab.permissions || [] : []);
  const can = (perm) => {
    if (isAdmin) return true;
    return Array.isArray(perm) ? perm.some((p) => labPermissions.has(p)) : labPermissions.has(perm);
  };

  return {
    user,
    isAuthenticated,
    loading,
    token,
    role,
    isCustomer,
    isDoctor,
    isHospitalAdmin,
    isAdmin,
    isLabStaff: role === 'lab_staff',
    lab,
    labEnabled: Boolean(lab?.enabled),
    labRole: lab?.lab_role || null,
    can,
  };
};

export default useAuth;
